module.exports = __webpack_public_path__ + "static/logo-9c87adc482ebf0d3a73cee54a3ec3c7a.png";